import React, {FC, useEffect, useState} from 'react'
import moment from 'moment-timezone'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {MessageType} from '../Types'
import NodataYet from '../../../../Components/NodataYet'
import {MessageDeliveryStatus, visualizeHiddenCharacters} from '../Common'
import {useGetSchedulerHistoryQuery} from '../../../../../services/cellcast'
import {Link, useParams} from 'react-router-dom'
import clsx from 'clsx'

const FileSchedulerMessageHistory = () => {
  const {id} = useParams()

  const {data, isLoading, isFetching, refetch} = useGetSchedulerHistoryQuery({id})
  return (
    <div className=''>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Scheduler Messages History</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'></div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data && data?.data?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th className='p-0'>Sent Date</th>
                        <th className='p-0 min-w-30px ps-3'>From / CustomerID</th>
                        <th className='p-0 min-w-30px ps-3'>Receiver</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.map((key, i) => {
                            const badgeClass = clsx({
                              'badge badge-light-success fw-bold': [
                                MessageDeliveryStatus.SEND,
                                MessageDeliveryStatus.DELIVERED,
                                MessageDeliveryStatus.RECEIVED,
                              ].includes(key?.status),
                              'badge badge-light-danger fw-bold': [
                                MessageDeliveryStatus.REJECTED,
                                MessageDeliveryStatus.BLOCKED,
                                MessageDeliveryStatus.FAILED,
                                MessageDeliveryStatus.EXPIRED,
                              ].includes(key?.status),
                              'badge badge-light-warning fw-bold': [
                                MessageDeliveryStatus.QUEUED,
                              ].includes(key?.status),
                            })

                            return (
                              <React.Fragment key={i}>
                                <tr className='border-dashed border-2 border-bottom'>
                                  <td className='top-align'>
                                    <div className='symbol symbol-50px me-2'>
                                      <span className='symbol-label badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                        {MessageType.SMS.toString()}
                                      </span>
                                    </div>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>
                                      {moment(key?.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                    </span>
                                  </td>
                                  <td className='top-align'>{key?.sender || '-'}</td>
                                  <td className='top-align'>{key?.receiver || '-'}</td>
                                  <td className='top-align'>
                                    <div className='message-display'>
                                      {visualizeHiddenCharacters(key?.message || '-')}
                                    </div>
                                  </td>

                                  <td className='top-align'>
                                    <span className={badgeClass}>{key?.status.toUpperCase()}</span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          })}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message='No recent file scheduler sms messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default FileSchedulerMessageHistory
